import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import DetailPanel from './DetailPanel';
import GeminiPanel from './GeminiPanel';
import { useTheme } from '@mui/material';
import { useContext, useEffect, useState } from 'react';
import { MessageContext } from '../../context/MessageContext';
import { SearchTopic } from '../../enum/SearchTopics';

interface RightPanelContentProps {
  selectedOption: SearchTopic;
  data: any;
  forceOpenDetailTab: number;
}

const RightPanelContent = (props: RightPanelContentProps) => {
  const [selectedTab, setSelectedTab] = useState(0);
  const theme = useTheme();
  const { isLlmQueryLoading, geminiChat, messages } = useContext(MessageContext);

  useEffect(() => {
    setSelectedTab(0);
  }, [props.data, messages, props.forceOpenDetailTab]);

  const handleTabChange = (_: any, tabIndex: number) => {
    setSelectedTab(tabIndex);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        width: '100%',
        backgroundColor: theme.palette.secondary.main,
        borderTopLeftRadius: '25px',
        borderBottomLeftRadius: '25px',
        padding: theme.spacing(3),
        right: 0,
        top: 0,
        bottom: 0,
      }}
    >
      <Tabs value={selectedTab} onChange={handleTabChange}>
        <Tab label={<span style={{ textTransform: 'none' }}>Details</span>} />
        <Tab
          label={<span style={{ textTransform: 'none' }}>Public LLM Response</span>}
          disabled={isLlmQueryLoading || geminiChat.length <= 1}
        />
      </Tabs>
      {selectedTab === 0 && <DetailPanel data={props.data} selectedOption={props.selectedOption} />}
      {selectedTab === 1 && <GeminiPanel />}
    </Box>
  );
};

export default RightPanelContent;
